module.exports = __webpack_public_path__ + "static/media/jenkins.58312318.avif";